import moment from 'moment';
import 'prosemirror-state';
import 'prosemirror-model';

/**
 * 统一样式前缀
 */ var CLASSNAME_PREFIX = "ct";

var classNamePrefix = function(className) {
    var prefix = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : CLASSNAME_PREFIX;
    return "".concat(prefix, "-").concat(className);
};

function styleInject(css, ref) {
    if (ref === void 0) ref = {};
    var insertAt = ref.insertAt;
    if (!css || typeof document === "undefined") {
        return;
    }
    var head = document.head || document.getElementsByTagName("head")[0];
    var style = document.createElement("style");
    style.type = "text/css";
    if (insertAt === "top") {
        if (head.firstChild) {
            head.insertBefore(style, head.firstChild);
        } else {
            head.appendChild(style);
        }
    } else {
        head.appendChild(style);
    }
    if (style.styleSheet) {
        style.styleSheet.cssText = css;
    } else {
        style.appendChild(document.createTextNode(css));
    }
}

var css_248z = '.pk-view-container .ct-time{box-sizing:border-box;margin:0 2px 0 0;list-style:none;padding:6px 11px;position:relative;display:inline-flex;align-items:center;background:#fff;border:1px solid #d9d9d9;border-radius:2px;transition:border .3s,box-shadow .3s}.pk-view-container .ct-time .icon{width:16px;height:16px;margin-left:11px;background:url("data:image/svg+xml,%3C%3Fxml version%3D%221.0%22 standalone%3D%22no%22%3F%3E%3Csvg xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 width%3D%2214px%22 height%3D%2214px%22 class%3D%22icon%22 viewBox%3D%220 0 1024 1024%22%3E%3Cpath d%3D%22M880 184H712v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H384v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H144c-17.7 0-32 14.3-32 32v664c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V216c0-17.7-14.3-32-32-32zm-40 656H184V460h656v380zM184 392V256h128v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h256v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h128v136H184z%22 %2F%3E%3C%2Fsvg%3E") no-repeat 0;opacity:.25}';
styleInject(css_248z);

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
var timeRender = function timeRender() {
    var config = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    _classCallCheck(this, timeRender);
    this.fragmentRender = function(node) {
        var date = node.getAttribute("datetime");
        var isShowTime = node.getAttribute("data-isshowtime") === "true";
        var text = isShowTime ? moment(+date).format("YYYY-MM-DD HH:mm:ss") : moment(+date).format("YYYY-MM-DD");
        var newNode = document.createElement("span");
        newNode.classList.add(classNamePrefix("time"));
        newNode.innerHTML = "".concat(text, ' <span class="icon"></span>');
        node.parentNode.insertBefore(newNode, node.nextSibling);
        node.parentNode.removeChild(node);
    };
    this.fragmentCls = ".".concat(classNamePrefix("time"));
    this.config = config;
};

export default timeRender;
//# sourceMappingURL=render.js.map
